import $ from 'jquery';

import BaseController from 'chairisher/_controller';

import bindProfileAnalytics from 'chairisher/analytics/profile';

import { logAmplitudeClickEvent, ShopPosition } from 'chairisher/util/analytics';

/**
 * Controller which binds actions for the business article list view.
 */
class BusinessArticlePortfolioController extends BaseController {
    bindPageAnalytics() {
        super.bindPageAnalytics();

        bindProfileAnalytics('screen - news');

        $('[data-action-type=view_on_website]').on('click', ({ currentTarget }) => {
            const $link = $(currentTarget);

            logAmplitudeClickEvent($link.text().trim(), ShopPosition.NEWS_RAIL, $link.attr('href'));
        });
    }
}

export default BusinessArticlePortfolioController;
